// extracted by mini-css-extract-plugin
export default {"button":"Button_button__iEiBG","outline":"Button_outline__LgVks","ghost":"Button_ghost__xcMdm","sm":"Button_sm__UWopw"};